import { Typography } from "@mui/material";
import { Box, Switch } from "@procore/core-react";
import { useTranslation } from "react-i18next";

const switchLabelSx = {
    color: "text.primary",
    cursor: "pointer",
} as const;

interface ToggleWithTextProps {
    checked: boolean;
    onChange: () => void;
    label: string;
}

export const ToggleWithText = ({ checked, onChange, label }: ToggleWithTextProps) => {
    const { t } = useTranslation();
    return (
        <Box display="flex" alignItems="center" gap="0.5rem">
            <Switch checked={checked} onChange={onChange} id={`toggle-${label}`} style={{ flexShrink: 0 }} />
            <Typography component="label" htmlFor={`toggle-${label}`} sx={switchLabelSx}>
                {t(label)}
            </Typography>
        </Box>
    );
};
